module.exports = __webpack_public_path__ + "img/completar.e49e3f84.svg";